import { SimplePage } from "@/app/_/marketing/SimplePage";
import { NaturalLanguageFeature } from "@/app/_/sections/3FeaturesSection/NaturalLanguageFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Ledger & integrations"
      title="Bank feeds, documents, and a real general ledger."
      subtitle="Connect banks and payment processors via Plaid and Stripe. Sync transactions, match receipts, issue invoices with online payment, and post everything to journal entries and a chart of accounts you control."
      secondaryCta={{
        label: "See the ledger",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "transactions-ledger",
        alt: "Posted transactions with a transaction open in detail",
      }}
      capabilities={[
        {
          title: "Every line, explained.",
          description:
            "Open any transaction to see its account, category, tags, matched documents, and the journal entry it posted to.",
          imageName: "crop-transaction-detail",
        },
        {
          title: "Double-entry underneath.",
          description:
            "Booking creates balanced journal entries automatically. Drafts, pending, and posted states are always visible.",
          imageName: "crop-journal-entries",
        },
        {
          title: "Documents where they belong.",
          description:
            "Receipts, bills, and invoices are parsed into line items and linked to the payments that settle them.",
          imageName: "crop-documents",
        },
      ]}
      illustration={{
        title: "Connected, not copied.",
        description:
          "Transactions, accounts, documents, and conversations are one linked graph — ask about any of them and get the rows behind the answer.",
        render: () => NaturalLanguageFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/triage", "/platform/reports"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
